import { render, staticRenderFns } from "./UpdatePaymentMethodForm.vue?vue&type=template&id=218a88b4&scoped=true&"
import script from "./UpdatePaymentMethodForm.vue?vue&type=script&lang=js&"
export * from "./UpdatePaymentMethodForm.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePaymentMethodForm.vue?vue&type=style&index=0&id=218a88b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218a88b4",
  null
  
)

export default component.exports